import script from "./UserAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccount.vue?vue&type=script&setup=true&lang=js"

import "./UserAccount.vue?vue&type=style&index=0&id=6a820c7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a820c7e"]])

export default __exports__